import { jsx as _jsx } from "react/jsx-runtime";
import { Text, useLocalizeMessage } from 'libs.nucleus';
/**
 * Empty state shown on the chart detail page before the user has run a query.
 * Matches the design: white card with padding, inner bordered block, centered text.
 */
export const ChartEmptyState = () => {
    const translate = useLocalizeMessage();
    return (_jsx("div", { className: 'bg-white rounded-xl p-5 shadow-sm', children: _jsx("div", { className: 'flex items-center justify-center border border-neutral-200 rounded-lg min-h-[200px]', children: _jsx(Text, { size: 'sm', className: 'text-neutral-500', children: translate('Select some data in the settings panel to make a chart.') }) }) }));
};
